module.exports = __webpack_public_path__ + "img/202412_flora_01.9f499877.jpg";